const form = document.querySelector("form.shareholder-opt-in-form");

if (form) {
  const typeInputs = form.querySelectorAll("input[name='type']");
  const shareholderInput = form.querySelector("input[name='company']");
  const investorInput = form.querySelector("input[name='investment-firm']");

  const updateConditionalRequiredFields = function () {
    const selectedType = form.querySelector("input[name='type']:checked")?.value;

    if (shareholderInput) {
      const isShareholder = selectedType === "Shareholder";
      shareholderInput.required = isShareholder;

      if (!isShareholder) {
        shareholderInput.value = "";
      }
    }

    if (investorInput) {
      const isInvestor = selectedType === "Investor";
      investorInput.required = isInvestor;

      if (!isInvestor) {
        investorInput.value = "";
      }
    }
  };

  typeInputs.forEach(typeInput => {
    typeInput.addEventListener("change", updateConditionalRequiredFields);
  });

  updateConditionalRequiredFields();
}
